  <template>
  <div id="children-page">
    <v-sheet max-height="800" class="overflow-y-auto" >
        <v-data-iterator
          :items="children"
          :items-per-page.sync="itemsPerPage"
          :page="page"
          :search="search"
          :sort-by="sortBy.toLowerCase()"
          hide-default-footer
        >
        <template v-slot:header >
            <v-toolbar
              dark
              dense
              color="#018891"
              class="mb-1"

            >

            <v-text-field
              v-model="search"
              clearable
              flat
              dense
              solo-inverted
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Enfants, groupe"
            ></v-text-field>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-spacer></v-spacer>

              <div v-if="numberOfPagesIsNotOne">

                <v-spacer></v-spacer>
                <span
                  class="mr-4
            white--text"
                >
            Page {{ page }} sur {{ numberOfPages }}
          </span>

                <v-btn

                  dark
                  color="#0f3057"
                  class="mr-1"
                  @click="formerPage"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  dark
                  color="#0f3057"
                  class="ml-1"
                  @click="nextPage"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                </div>
              </template>
            </v-toolbar>
        </template>
        <template v-slot:default="props" >
        <v-row class="mx-auto" >
          <v-col  md="3" class="pa-3 d-flex flex-column"  v-for="child in props.items" :key="child.id">
            <v-card elevation="2" class="elevation-5 flex d-flex flex-column">

              <v-img height="150" src="../assets/arthur.jpeg"></v-img>
              <v-card-title
                ><h2>{{ child.name }}</h2></v-card-title
              >
              <v-card-subtitle>
                  <p class="sub-title">{{ child.age }} - {{ child.gender }} - {{ child.group }}</p>
              </v-card-subtitle>
              <v-card-text>
                <v-divider class="mx-4"></v-divider>
                <v-row class="mx-0">
                  <v-col align-self="start">
                    <h3>Parents</h3>
                    <ul v-for="parent in child.parents" :key="parent.id">
                      <li>{{ parent.name }}</li>
                    </ul>
                    <h3 v-if="child.particularities">Particularités</h3>
                    <ul v-for="particularity in child.particularities" :key="particularity.id">
                      <li>{{ particularity.name }}</li>
                    </ul>
                  </v-col>

                  <v-col>
                    <h3>Téléphones</h3>
                    <ul v-for="phone in child.emergencyPhones" :key="phone.id">
                      <li>{{ phone.number }}</li>
                    </ul>
                    <h3 v-if="child.allergies">Allergies</h3>
                    <ul v-for="allergy in child.allergies" :key="allergy.id">
                      <li>{{ allergy.name }}</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn class="inverted-button" ext @click="show_more(child)">
                  Voir plus de détails
                </v-btn>
                <v-btn class="button"text @click="show_more(child)">
                  Journal de bord
                </v-btn>

              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        </template>
        </v-data-iterator>
    </v-sheet>
  <ChildrenInformation v-model="dialog" />
  </div>

</template>



<style lang="scss">
#children-page .v-card ul,
#children-page .v-card p {
  font-size: 0.9em !important;
  color: #383838;
}
#children-page .button{
  background-color: #0f3057;
  color: white !important;
  border-radius: 0px !important;
  margin: auto auto 10px;

}

#children-page .inverted-button{
  background-color: #018891;
  color: white !important;
  border-radius: 0px !important;
  margin: auto auto 10px;

}
@media only screen and (max-width: 600px) {
  #children-page .inverted-button{  font-size: 0.6em; }
  #children-page .button{font-size: 0.6em; }
}
#children-page h2,
#children-page h3 {
  color: #018891;
}
#children-page h3 {
  font-size: 1.1em !important;
  font-weight: normal;
}
#children-page .sub-title {
  font-size: 1.2em;
  font-weight: bold;
}
</style>

<script>

import ChildrenInformation from './ChildrenInformation'
const childrenConst = [
  {
    name: "Arthur de Mahieu",
    age: "9 mois",
    gender: "Garçon",
    parents: [
      { id: 1, name: "Jean" },
      { id: 2, name: "Jeanne" }
    ],
    group: "Les capuccins",
    emergencyPhones: [
      { id: 1, number: "418-262-7201" },
      { id: 2, number: "418-262-7201" }
    ]
  },
  {
    name: "Jean de Mahieu",
    age: "9 mois",
    gender: "Garçon",
    parents: [
      { id: 1, name: "Jean" },
      { id: 2, name: "Jeanne" }
    ],
    group: "Les lions",
    emergencyPhones: [{ id: 1, number: "418-262-7201" }]
  },
  {
    name: "Charles de Mahieu",
    age: "9 mois",
    gender: "Garçon",
    parents: [
      { id: 1, name: "Jean" },
      { id: 2, name: "Jeanne" }
    ],
    group: "Les chiens",
    emergencyPhones: [{ id: 1, number: "418-262-7201" }]
  },
  {
    name: "Mathieu de Mahieu",
    age: "9 mois",
    gender: "Garçon",
    parents: [
      { id: 1, name: "Jean" },
      { id: 2, name: "Jeanne" }
    ],
    group: "Les capuccins",
    emergencyPhones: [{ id: 1, number: "418-262-7201" }]
  },
  {
    name: "Claire de Mahieu",
    age: "9 mois",
    gender: "Garçon",
    parents: [
      { id: 1, name: "Jean" },
      { id: 2, name: "Jeanne" }
    ],
    group: "Les capuccins",
    emergencyPhones: [{ id: 1, number: "418-262-7201" }],
    allergies: [{
      name: "noisette"
    },{
      name: "noisette"
    },{
      name: "noisette"
    }],
    particularities: [{name: "Epilleptique"}]
  }
];

export default {
  components: {ChildrenInformation},
  data() {
    return {
      children: childrenConst,
      itemsPerPageArray: [4, 8, 12],
      itemsPerPage: 8,
      page: 1,
      sortBy: 'name',
      search: '',
      dialog: false,
    };
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.children.length / this.itemsPerPage)
    },
    numberOfPagesIsNotOne () {
      return this.numberOfPages !== 1;
    },
    filteredKeys () {
      return this.keys.filter(key => key !== 'Name')
    },
  },
  methods: {
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },
    show_more(child) {
     this.dialog = child
    },
    components : {
      ChildrenInformation
    }
  },
};
</script>
